var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"align":"left","body-border-variant":"white","border-variant":"white","body-class":"p-0 rounded-top  border border-info"}},[_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"293px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }